import React from "react";
import PropTypes from 'prop-types';
import { ProgressSurveyQuestion } from "../utils/types";
import QuestionDefinitionsList from './QuestionDefinitionsList';
import QuestionDefinitionsCloseButton from './QuestionDefinitionsCloseButton';
import css from './DesktopQuestionDefinitionView.css';

export default class DesktopQuestionDefinitionView extends React.Component {

  constructor() {
    super();
    this.closeButtonRef = React.createRef();
    this.onCloseButtonFocus = this.onCloseButtonFocus.bind(this);
  }
  
  componentDidUpdate(prevProps) {
    // If the component updated and the ref is null, it means that showQuestionDefinition
    // is false and we don't render the close button. Therefore, nothing to do here
    if ( !this.closeButtonRef.current ) return;
    
    // If the component updates and we display the close button, we listen to the focusin event
    // This way we can get the element previously focused and return focus to it
    // if we close the drawer
    // We need to use this workaround because the focus and blur callbacks do not
    // behave correctly in IE11: https://github.com/facebook/react/issues/3751 
    this.closeButtonRef.current.addEventListener('focusin', this.onCloseButtonFocus);

    // We only want to focus on the close button if the user has opened the drawer
    // When the drawer is already open, i.e., when we are on XXL screens, do not change focus
    if ( !prevProps.showQuestionDefinitions ) this.closeButtonRef.current.focus();
  }

  onCloseButtonFocus(e) {
    this.previouslyFocusedElement = e.relatedTarget;
  }

  onCloseButtonClick() {
    this.props.onClose();
    this.previouslyFocusedElement.focus();
  }
  
  render() {
    if (!this.props.showQuestionDefinitions) return null;
    return (
      <div className={css['container']}>
        <QuestionDefinitionsCloseButton ref={this.closeButtonRef} onClick={this.onCloseButtonClick.bind(this)} />
        <QuestionDefinitionsList surveyQuestions={this.props.surveyQuestions}/>
      </div>
    )
  }
}

DesktopQuestionDefinitionView.propTypes = {
  surveyQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  onClose: PropTypes.func.isRequired,
  showQuestionDefinitions: PropTypes.bool.isRequired
}
